import React, { useState } from 'react';

import DetachElement from '../../elements/DetachElement';
import { ROLES } from '../../services/AdminPolicyService';

import SuperAgentsList from './SuperAgentsList';

function ResourceSuperAgents({ url, cardTitle }: { url: string; cardTitle?: string }) {
    const [loading, setLoading] = useState(false);

    const getLinks = (id: number) => {
        const params = { super_agent: id };

        return <DetachElement url={url} params={params} action={() => setLoading(true)} roles={ROLES.MAIN_ADMINS} />;
    };

    return (
        <SuperAgentsList
            url={url}
            cardTitle={cardTitle ?? 'Super Agents'}
            getLinks={getLinks}
            loading={loading}
            setLoading={setLoading}
        />
    );
}

export default ResourceSuperAgents;
